import { render, staticRenderFns } from "./CifLinkDirsDialog.vue?vue&type=template&id=8e6601a6&scoped=true"
import script from "./CifLinkDirsDialog.vue?vue&type=script&lang=js"
export * from "./CifLinkDirsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6601a6",
  null
  
)

export default component.exports